"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const ProductSchema_1 = require("./ProductSchema");
const mongo_1 = require("../utility/mongo");
const constants_1 = require("../../constants");
exports.OrderSchema = joi_1.default.object({
    _id: mongo_1.ObjectIdSchema,
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    additionalData: joi_1.default.object({
        attachment: joi_1.default.string().allow(null),
        externalId: joi_1.default.string().allow(null),
        notes: joi_1.default.string().allow(null, '')
    }).allow(null),
    cancelledBy: joi_1.default.object({
        email: joi_1.default.string()
            .email({ tlds: { allow: !constants_1.isBrowser } })
            .allow(null)
    }),
    host: joi_1.default.object({
        email: joi_1.default.string().allow(null),
        name: joi_1.default.string().required(),
        phone: joi_1.default.string().required()
    }).required(),
    payment: joi_1.default.object({
        status: joi_1.default.string().required(),
        transactionId: joi_1.default.string().allow(null)
    }).required(),
    product: ProductSchema_1.ProductSchema.required(),
    shootUuid: joi_1.default.string().uuid(),
    status: joi_1.default.any().allow('confirmed', 'cancelled').required(),
    user: joi_1.default.object({
        id: mongo_1.ObjectIdSchema,
        email: joi_1.default.string().required(),
        // FIXME: it is indeed possible to create users without organizationUuid
        // how do we create such orders, but we have those in DB
        organizationUuid: joi_1.default.string().allow(null),
        name: joi_1.default.string().allow(null),
        phone: joi_1.default.string().allow(null),
        email_verified: joi_1.default.boolean(),
        sub: joi_1.default.string(),
        locale: joi_1.default.string()
    }).required(),
    billingAddressUuid: joi_1.default.string().uuid().allow(null),
    uuid: joi_1.default.string().uuid().required()
}).meta({ className: 'Order' });
//# sourceMappingURL=OrderSchema.js.map